export default __webpack_public_path__ + "static/media/skillful.1adef2cd.svg";